
import { computed, defineComponent, PropType } from 'vue'
import { AgreementsListModel, useAgreementModule } from '@/modules/agreements'
import { AgreementSearchFilter } from '@/views/_shared/search-list/types'
import { useOrganizationModule } from '@/modules/organizations'
import { AgreementsRouteNames } from '@/router/routes-names'
import { useRoute, useRouter } from 'vue-router'
import { useAPIPagination } from '@/views/_shared/search-list/pagination'
import { FormModelCacheTag } from '@/modules/_shared/forms'
import AgreementStatusBadge from '@/components/agreements/agreement-status-badge.vue'

export default defineComponent({
    name: 'agreements-list',
    components: { AgreementStatusBadge },
    props: {
        agreements: {
            type: Array as PropType<AgreementsListModel[]>
        },
        filter: {
            type: Object as PropType<AgreementSearchFilter>
        }
    },
    async setup (props) {
        const router = useRouter()
        const route = useRoute()
        const { getAgreements, agreementsFilter, agreementsCount } = useAgreementModule()
        const { getOrganizationsSimplified, organizationsSimplifiedByOrganizationId } = useOrganizationModule()

        const agreementColumns = ([
            { name: 'shortId', label: 'ID', field: 'shortId', sortable: true, align: 'left' },
            { name: 'type', label: 'Type', field: 'type', sortable: true, align: 'left' },
            { name: 'status', label: 'Status', field: 'status', sortable: true, align: 'left' },
            { name: 'organization', label: 'Organization', field: (row: AgreementsListModel) => getOrganizationName(row.organizationId), sortable: true, align: 'left' },
            { name: 'name', label: 'Name', field: 'name', sortable: true, align: 'left', classes: 'agreement-name' },
            { name: 'packages', label: 'Packages', field: 'packages', align: 'left' },
            { name: 'startDate', label: 'From', field: 'startDate', sortable: true, align: 'left' },
            { name: 'endDate', label: 'To', field: 'endDate', sortable: true, align: 'left' },
            { name: 'createdAt', label: 'Created At', field: 'createdAt', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const getOrganizationName = (id: number) => {
            return organizationsSimplifiedByOrganizationId.value.get(String(id))?.companyName
        }

        const currentPage = computed(() => route.query.page === null ? '1' : route.query.page)

        const { loading, pagination, onRequest } = useAPIPagination(agreementsFilter, getAgreements, agreementsCount, currentPage, false, FormModelCacheTag.AGREEMENTS_LIST_FILTERS)

        await onRequest({
            filter: props.filter || {
                id: '',
                status: '',
                type: '',
                organization: '',
                name: '',
                shortId: 0,
                dateFrom: '',
                dateTo: '',
                packageIds: []
            } as AgreementSearchFilter,
            pagination: pagination.value
        })

        function onViewAgreement (evt: PointerEvent | null, props: AgreementsListModel) {
            router.push({ name: AgreementsRouteNames.SHOW, params: { agreementId: props.agreementId }, query: { page: route.query.page } })
        }

        function onViewMembers (props: AgreementsListModel) {
            router.push({ name: AgreementsRouteNames.MEMBERS, params: { agreementId: props.agreementId }, query: { page: route.query.page } })
        }

        if (organizationsSimplifiedByOrganizationId.value.size === 0) {
            await getOrganizationsSimplified()
        }
        return {
            agreementColumns,
            onViewAgreement,
            onViewMembers,
            loading,
            pagination,
            onRequest
        }
    }
})
